
import { Mixins, Component } from 'vue-mixin-decorator';
import { namespace } from 'vuex-class';
import { findWhere } from 'underscore';

import FieldMixin from '@/mixins/create/field';
import DropdownMixin from '@/mixins/common/dropdown';
import dictionariesService from '@/services/dictionaries-service';
import { Dictionaries, Dictionary } from '@/services/dictionaries-service';
import { VuexAction } from '@/types/functions';

interface IMixins extends FieldMixin, DropdownMixin {}

const commonStore = namespace('common');

@Component
export default class StepContactsLocationRegion extends Mixins<IMixins>(
  DropdownMixin,
  FieldMixin
) {
  @commonStore.State dictionaries!: Dictionaries;
  @commonStore.Action setDictionary!: VuexAction;

  private open() {
    this.openDropdown();

    document.body.classList.add('body_state-dropdown-style_visible');
  }

  private close() {
    this.closeDropdown();

    document.body.classList.remove('body_state-dropdown-style_visible');
  }

  private toggle() {
    const isVisible = this.toggleDropdown();

    isVisible
      ? document.body.classList.add('body_state-dropdown-style_visible')
      : document.body.classList.remove('body_state-dropdown-style_visible');
  }

  private get dictionary() {
    const url = dictionariesService.buildUrl('country', {
      country: this.data.country,
    });

    return this.dictionaries[url] || [];
  }

  private get region() {
    return this.data.region;
  }

  private set region(value) {
    this.clearError({ name: 'country' });
    this.clearError({ name: 'region' });
    this.clearError({ name: 'cityId' });
    this.setField({ region: value });
    this.setField({ cityId: null });
  }

  private get regionName() {
    const region = findWhere(this.dictionaries.region, {
      id: this.data.region,
    });

    if (!region) {
      return 'Область';
    }

    return region.name;
  }

  private get urlData() {
    return {
      country: this.data.country,
      region: this.data.region,
    };
  }

  private get url() {
    return dictionariesService.buildUrl('region', this.urlData);
  }

  private onChange() {
    this.close();

    this.url &&
      dictionariesService.getDictionary(
        'region',
        this.urlData,
        (data: Dictionary) => {
          this.setDictionary({
            rootName: 'city',
            name: this.url,
            dictionary: data,
          });
        }
      );
  }
}
